import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import { SingleValue } from "react-select";
import { all_routes } from "../../router/all_routes";
import { _post } from "../../Utils/Helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import dayjs from 'dayjs';

const AssignmentsForm = () => {
  const { user, subjects, classes, selected_branch } = useSelector((state: RootState) => state.auth);

  interface Question {
    question_type: string;
    option_a: string;
    option_b: string;
    option_c: string;
    option_d: string;
    marks: number;
    [key: string]: any;
    
  };
  const initialForm = {
    assignment_date: dayjs().format('YYYY-MM-DD'),
    class_name: "",
    teacher_name: "",
    teacher_id: "",
    submission_date: "",
    subject: "",
    title: "",
    correct_answer: "",
    marks: "",
    class_code: "",
    branch_id: selected_branch?.branch_id,
  };

  const initialQuestion = {
    question_type: "",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    true_false: "",
    correct_answer: "",
    marks: 0,
  };

  const [form, setForm] = useState(initialForm);
  const [question, setQuestion] = useState<Question>(initialQuestion);
  const [questions, setQuestions] = useState<Question[]>([]);
  const classOptions = classes?.length ? classes?.map((i: any) => ({
    label: i.class_name,
    value: i.class_name,
  })) : [];

  const subjectOptions = subjects?.length ? subjects?.map((i: any) => ({
    label: i.subject,
    value: i.subject,
  })) : [];

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleQuestionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuestion({ ...question, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (newValue: SingleValue<Option>, fieldName: string) => {
    setQuestion({ ...question, [fieldName]: newValue ? newValue.value : "" });
  };

  const handleAddQuestion = (e: React.FormEvent) => {
    e.preventDefault();

    // Validate required fields
    if (!question.question_type || !question.question_text) {
      alert("Please complete all required fields for the question.");
      return;
    }

    // If the question type is "Multiple Choice", generate options as an array
    let optionsArray = null;
    if (question.question_type === "Multiple Choice") {
      const options = ["option_a", "option_b", "option_c", "option_d"].map(
        (key) => ({
          value: question[key] || "",
          is_correct: question[key] === question.correct_answer,
        })
      );

      // Validate that all options are filled
      if (options.some((option) => !option.value)) {
        alert("Please fill in all options for the multiple-choice question.");
        return;
      }

      optionsArray = options; // Keep as an array for now
    }

    // Create the complete question object
    const newQuestion = {
      question_text: question.question_text,
      question_type: question.question_type,
      correct_answer: question.correct_answer, // Use correct_answer directly
      options: optionsArray, // Keep as array for now
      marks: question.marks || 5, // Default to 5 if no marks are specified
    };

    // Update the questions array with the new question
    setQuestions((prev: any) => [...prev, newQuestion]);
    console.log("New Question Added:", newQuestion);

    // Reset the question form
    setQuestion(initialQuestion);
  };


  const columns = [
    { title: "#", dataIndex: "id", render: (_: string, __: any, index: number) => index + 1 },
    { title: "Type", dataIndex: "question_type" },
    { title: "Question Text", dataIndex: "question_text" },
    { title: "Correct Answer", dataIndex: "correct_answer" },
    {
      title: "Action", render: (_: string, __: any, index: number) => (
        <button
          onClick={() => handleDeleteQuestion(index)}
          className="btn btn-sm btn-danger"
        >
          Delete
        </button>
      )
    },
  ];

  const handleDeleteQuestion = (index: number) => {
    setQuestions((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
  
    const formattedQuestions = questions.map((q: any) => ({
      ...q,
      options: q.options ? JSON.stringify(q.options) : null, // Convert to JSON only if options exist
    }));
    const total_marks = questions.reduce((total, question) => total + (question.marks || 0), 0);

    
    _post(`assignments`, {
      ...form,
      query_type: 'create',
      teacher_id:user.id,
      teacher_name:user.name,
      class_name:form.class_name,
      subject:form.subject,
      marks:total_marks,
      questions: formattedQuestions,
       branch_id: selected_branch?.branch_id},
   (res) => {
        if (res.success) {
          toast.success("Assignment submitted successfully!");
          setForm(initialForm);
          setQuestions([]);
        }
      },
      (err) => {
        toast.error("Error submitting assignment");
      }
    )
    console.log("Formatted Questions for Submission:", formattedQuestions);

    // Send formattedQuestions to the server
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Assignment For</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Academic </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Class Assignment
                </li>
              </ol>
            </nav>
          </div>

        </div>
        <div className="card">
          <div className="card-body p-3">
            <form >
              <div className="mb-3">
                <h4 className="form-label text-bold">Assignment Title</h4>
                <input
                  type="text"
                  name="title"
                  value={form.title}
                  onChange={handleFormChange}
                  className="form-control"
                />
              </div>

              <div className="row">
          <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">class</label>
                <CommonSelect
                  className="select"
                  options={classOptions}
                  handleChange={(newValue: SingleValue<Option>) =>
                    setForm((prev) => ({
                      ...prev,
                      class_name: newValue ? newValue.value : "",
                    }))
                  }
                  defaultValue={{
                    label: form.class_name,
                    value: form.class_name,
                  }}
                />
              </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Subject</label>
              <CommonSelect
                handleChange={(newValue: SingleValue<Option>) =>
                  setForm((prev) => ({
                    ...prev,
                    subject: newValue ? newValue.value : "",
                  }))
                }
                defaultValue={{
                  label: form.subject,
                  value: form.subject,
                }}
                options={subjectOptions}
              />
            </div>
          </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Assignment Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="10 May 2024"
                  name="assignment_date"
                  value={form.assignment_date}
                  onChange={handleFormChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Submission Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="12 May 2024"
                  name="submission_date"
                  value={form.submission_date}
                  onChange={handleFormChange}
                />
              </div>
            </div>
            </div>
          </form>

          <h4 className="text-center">Add Questions</h4>
          <form onSubmit={handleAddQuestion}>
            <div className="mb-3">
              <label className="form-label text-bold">Question Type</label>
              <CommonSelect
                className="select"
                options={[
                  { label: "Multiple Choice", value: "Multiple Choice" },
                  { label: "True/False", value: "True/False" },
                  { label: "Fill in the Blank", value: "Fill in the Blank" },
                  { label: "Short Answer", value: "Short Answer" },
                  { label: "Essay", value: "Essay" },
                ]}
                handleChange={(newValue) => handleSelectChange(newValue, "question_type")}
                defaultValue={{
                  label: question.question_type,
                  value: question.question_type,
                }}
              />
            </div>
            {question.question_type ? <>
              <div className="mb-3">
                <label className="form-label text-bold">Question Text</label>
                <input
                  type="text"
                  name="question_text"
                  value={question.question_text}
                  onChange={handleQuestionChange}
                  className="form-control"
                />
              </div>
              {question.question_type === "Multiple Choice" && (
                <div className="row">
                  <h4 className="text-center">Create Multiple Answers</h4>

                  {["A", "B", "C", "D"].map((label, index) => (
                    <div className="mb-3 col-md-6" key={index}>
                      <label>Option {label}</label>
                      <input
                        type="text"
                        name={`option_${label.toLowerCase()}`}
                        value={question[`option_${label.toLowerCase()}`] || ""}
                        onChange={handleQuestionChange}
                        className="form-control"
                      />
                    </div>
                  ))}

                  {/* Correct Answer Selector */}
                  {["option_a", "option_b", "option_c", "option_d"].every(
                    (opt) => question[opt]
                  ) ? (
                    <div className="row">
                    <div className="mb-3 col-md-6">
                      <label className="form-label text-bold">Correct Answer</label>
                      <CommonSelect
                        className="select"
                        options={["A", "B", "C", "D"].map((label) => ({
                          label: question[`option_${label.toLowerCase()}`],
                          value: question[`option_${label.toLowerCase()}`],
                        }))}
                        handleChange={(newValue: SingleValue<Option>) => handleSelectChange(newValue, "correct_answer")}
                        defaultValue={{
                          label: question.correct_answer,
                          value: question.correct_answer,
                        }}
                      />
                    </div>

              <div className="mb-3 col-md-6">
                <label className="form-label text-bold">Question Marks
                </label>
                <input
                  type="number"
                  minLength={2}
                  name="marks"
                  value={question.marks}
                  onChange={handleQuestionChange}
                  className="form-control"
                />
              </div>
              </div>
                  ) : (
                    <p className="text-warning text-center">Fill all the options</p>
                  )}

                </div>
              )}

              {question.question_type === "True/False" && (
                <>
                  <div className="mb-3 row">
                    <label className="form-label text-bold">Options</label>

                    <div className="mb-3 col-md-6">
                      <input
                        type="radio"
                        id="trueOption"
                        name="answer"
                        value="True"
                        checked={question.option_a === "True"}
                        onChange={(e) =>
                          setQuestion((prev) => ({ ...prev, option_a: e.target.value }))
                        }
                        className="form-check-input"
                      />
                      <label htmlFor="trueOption" className="form-check-label">
                        True
                      </label>
                    </div>

                    <div className="mb-3 col-md-6">
                      <input
                        type="radio"
                        id="falseOption"
                        name="answer"
                        value="False"
                        checked={question.option_a === "False"}
                        onChange={(e) =>
                          setQuestion((prev) => ({ ...prev, option_a: e.target.value }))
                        }
                        className="form-check-input"
                      />
                      <label htmlFor="falseOption" className="form-check-label">
                        False
                      </label>
                    </div>
                  </div>

                  {/* Correct Answer Selector */}
                  {question.option_a ? (
                    <div className="mb-3 col-md-6">
                      <label className="form-label text-bold">Correct Answer</label>
                      <CommonSelect
                        className="select"
                        options={[
                          { label: "True", value: "True" },
                          { label: "False", value: "False" },
                        ]}
                        handleChange={(newValue: SingleValue<Option>) => handleSelectChange(newValue, "correct_answer")}
                        defaultValue={{
                          label: question.correct_answer || "Select Correct Answer",
                          value: question.correct_answer || "",
                        }}
                      />
                    </div>
                  ) : (
                    <p className="text-warning text-center">Select an answer</p>
                  )}
                </>
              )}

              {question.question_type === "Fill in the Blank" && (
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label text-bold">Correct Answer</label>
                    <input
                      type="text"
                      value={question.correct_answer}
                      onChange={(e) =>
                        setQuestion((prev) => ({
                          ...prev,
                          correct_answer: e.target.value,
                        }))
                      }
                      className="form-control"
                      placeholder="Enter the correct_answer  answer"
                    />
                  </div>

                </div>
              )}
              {question.question_type === "Short Answer" && (
                <div className="mb-3">
                  <label className="form-label text-bold">Short Answer</label>
                  <input
                    type="text"
                    value={question.correct_answer}
                    onChange={(e) =>
                      setQuestion((prev) => ({
                        ...prev,
                        correct_answer: e.target.value,
                      }))
                    }
                    className="form-control"
                    placeholder="Enter the answer"
                  />
                </div>
              )}
              {question.question_type === "Essay" && (
                <div className="mb-3">
                  <label className="form-label text-bold">Essay Answer</label>
                  <textarea
                    rows={5}
                    value={question.correct_answer}
                    onChange={(e) =>
                      setQuestion((prev) => ({
                        ...prev,
                        correct_answer: e.target.value,
                      }))
                    }
                    className="form-control"
                    placeholder="Enter the answer"
                  />
                </div>)}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">Add Question</button>
              </div>

            </> : null}
          </form>
        </div>
      </div>
      <br />
      <div className="card">
        <div className="card-body p-0 py-3">
          <h4>Questions List</h4>
          <Table dataSource={questions} columns={columns} />
          <div className="text-center mt-4">
            <button onClick={handleSubmit} type="submit" className="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </div>
    </div >
  );
};

export default AssignmentsForm;
